import React from 'react'
import { URL_SRV_RAIZ } from '../../router/Url'

export const BkpReasignacionOT = ({ACTION,DATA}) => {
  return new Promise(async (resolve, reject) => {
    let query = await fetch(URL_SRV_RAIZ+'bkp_reasignacion_ot',{
      method: 'POST',
      headers: {
        'authorization': "marcuxo",
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ACTION,DATA})
    })
    let responsito = await query.json();
    // console.log(responsito);
    if(responsito.success){
      resolve(responsito.body)
    }else{
      resolve(null)
    }
  })
}
